export function renderEl($el, options = [], value = null) {
    if (options && options.length) {
        $el[0].selectize.clear(false); // false means trigger onChange event
        $el[0].selectize.clearOptions();
        $el[0].selectize.addOption(options);
        $el[0].selectize.setValue(value);
    } else {
        $el.val('');
        $el.trigger('change');
        $el.prop("disabled", false);
    }

    $el.parent().show();
};


export function updatePeopleType($roles, rolesOptions, value) {
    renderEl($roles, getSelectizeOptions(rolesOptions[value]), 0);
};

export function getSelectizeOptions(objects) {
    let selectizeOptions = [];

    for (const id in objects) {
        let option = {
            value: id,
            text: objects[id]
        };
        selectizeOptions.push(option);
    }

    return selectizeOptions;
};
